import flow from "lodash/fp/flow";
import getOr from "lodash/fp/getOr";
import find from "lodash/fp/find";
import filter from "lodash/fp/filter";
import flatMap from "lodash/fp/flatMap";

import { filterByDisplayIf } from "utils";
import { selectUserChoiceValues } from "store/app";

export default function selectAllBladePatternOptions(state) {
  const userChoiceValues = selectUserChoiceValues(state);
  const { selectedCustomisationId, selectedProductId } = state.app;
  return flow(
    getOr([], ["app", "formData", "products"]),
    find(({ id }) => id === selectedProductId),
    getOr([], ["customisations"]),
    find(({ id }) => id === selectedCustomisationId),
    getOr([], ["help", "content", 0, "componentProps", "groupedPatterns"]),
    flatMap(getOr([], "patterns")),
    filter((aPattern) =>
      filterByDisplayIf(userChoiceValues)(aPattern.displayIf)
    )
  )(state);
}
